import React from 'react';
import { Redirect } from 'react-router';
import { ERoutesFranchiseePrivate } from 'common/models/routesModel';

export const RootSalesOpsPage: React.FC = () => <Redirect to={ERoutesFranchiseePrivate.StoreList} />;
